<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between border-b pb-3">
      <h2 class="text-xl font-semibold tracking-tight">Certificates</h2>
      <a href="/certificates" class="text-sm font-medium hover:underline text-muted-foreground">View All &rarr;</a>
    </div>

    <div class="flex flex-col mt-0">
      <a 
        v-for="cert in certificates" 
        :key="cert.id"
        :href="cert.link"
        target="_blank"
        rel="noopener noreferrer"
        class="group flex flex-col sm:flex-row sm:items-center justify-between py-4 border-b last:border-0 hover:bg-muted/50 px-2 -mx-2 transition-colors cursor-pointer"
      >
        <div class="flex flex-col gap-1">
          <h3 class="font-semibold text-foreground group-hover:text-primary transition-colors">{{ cert.title }}</h3>
          <span class="text-sm text-muted-foreground">{{ cert.issuer }}</span>
        </div>
        <span class="text-xs font-mono text-muted-foreground mt-2 sm:mt-0">{{ cert.date }} <font-awesome-icon icon="external-link-alt" class="h-2.5 w-2.5" /></span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CertificatesSection",
  data() {
    return {
      certificates: [
        {
          id: 1,
          title: "Github Foundations",
          issuer: "Github",
          date: "2025",
          link: "https://www.credly.com/badges/e897f710-46d0-4a8b-9c02-bfdb7d6626fe",
        },
        {
          id: 2,
          title: "IBM Front-End Developer",
          issuer: "IBM",
          date: "2025",
          link: "https://www.coursera.org/account/accomplishments/specialization/AJU6WCIQSPXI",
        },
        {
          id: 3,
          title: "Technical Support Fundamentals",
          issuer: "Google",
          date: "2025",
          link: "https://www.coursera.org/account/accomplishments/records/FNJSFT0TW3Q4",
        },
        {
          id: 4,
          title: "Introduction to Cybersecurity",
          issuer: "Cisco",
          date: "2023",
          link: "https://www.credly.com/badges/ec846f44-d2cf-4ba5-9fa8-78d568be9118",
        },
      ]
    };
  }
};
</script>
